import { Nullable } from '@types'

import { ShortlistSortOrder } from '@modules/shortlist/types'
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined'

import { SortArrowBox } from './SortArrow.styles'

interface SortArrowProps {
  isActive: boolean
  order?: Nullable<ShortlistSortOrder>
  isHovered: boolean
}

const SortArrow = ({ isActive, order, isHovered }: SortArrowProps) => {
  const arrowColor = isActive ? 'primary' : 'inherit'

  return (
    <SortArrowBox $isActive={isActive} $isHovered={isHovered} $order={order}>
      <ArrowUpwardOutlinedIcon
        sx={{
          transition: 'none',
          transform: isActive && order === ShortlistSortOrder.DESC ? 'rotate(180deg)' : 'none',
        }}
        color={arrowColor}
      />
    </SortArrowBox>
  )
}

export default SortArrow
